import $ from 'jquery';

class AddRemoveSelectFields {
    constructor () {
        this.$removeButton = $('.js-profile-select-remove-btn');
        this.$addButton = $('.js-profile-select-add-btn');
        this.$selectFieldClass = '.js-profile-select-field';

        this.$removeButton.on('click', $.proxy(this.removeSelect, this));
        this.$addButton.on('click', $.proxy(this.addSelect, this));
    }

    removeSelect (e) {
        e.preventDefault();
        const $elem = $(e.currentTarget);

        $elem.parent().addClass('is-hidden');
    }

    addSelect (e) {
        e.preventDefault();
        const $elem = $(e.currentTarget);
        const $firstHiddenSelect = $elem.parent().find(this.$selectFieldClass + '.is-hidden').first();

        $firstHiddenSelect.removeClass('is-hidden');
    }
}

export default AddRemoveSelectFields;
